/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import {ExdsImage, ExdsLayout, ExdsText} from '@exds/core';
import React from 'react';
import './AppHeader.scss';

export default function AppHeader({appInfo}) {
  return (
    <ExdsLayout alignItems="flex-start" display="flex" className='app-header-container'>
      <ExdsImage src={appInfo.imgSrc} alt={appInfo.imgAlt} className='app-logo' />
      <ExdsText primitive="div" className="app-header-text">
        <ExdsText primitive="h2" className='app-header'>{appInfo.headerTitle}</ExdsText>
        <ExdsText primitive="span" className='app-sub-header'>{appInfo.headerHelperText}</ExdsText>
      </ExdsText>
    </ExdsLayout>
  );
}
